import {Auth} from 'aws-amplify';
import * as Sentry from '@sentry/vue';

export const signIn = async ({commit, dispatch}: any, {username, password}: any) => {
  try {
    commit('setUsername', username);
    const res = await Auth.signIn(username, password);
    if (res.challengeName) {
      throw ({
        code: 'NEW_PASSWORD_REQUIRED',
        message: 'You have to set a new Password',
      });
    }
    return true;
  } catch (err: any) {
    dispatch('common/snackbar/warning', err, {root: true});
    if (err.code) {
      commit('setChallenge', err.code);
    }
    return false;
  }
};
// @ts-ignore
export const completeNewPassword = async ({dispatch}, {username, password, newPassword}) => {
  try {
    const user = await Auth.signIn(username, password);
    await Auth.completeNewPassword(user, newPassword, {});
    return true;
  } catch (err: any) {
    dispatch('common/snackbar/warning', err, {root: true});
    return false;
  }
};
// @ts-ignore
export const signUp = async ({commit, dispatch}, {email, username, password}) => {
  try {
    commit('setUsername', username);
    await Auth.signUp({username, password, attributes: {email}});
    return true;
  } catch (err: any) {
    dispatch('common/snackbar/warning', err, {root: true});
    return false;
  }
};
// @ts-ignore
export const confirmSignUp = async ({dispatch}, {username, code}) => {
  try {
    await Auth.confirmSignUp(username, code);
    dispatch('common/snackbar/success', 'User confirmed!', {root: true});
    return true;
  } catch (err: any) {
    dispatch('common/snackbar/warning', err, {root: true});
    return false;
  }
};
// @ts-ignore
export const resendSignUp = async ({dispatch}, {username}) => {
  try {
    await Auth.resendSignUp(username);
    dispatch('common/snackbar/success', 'Code has been resent. Please check your email.', {root: true});
    return true;
  } catch (err: any) {
    dispatch('common/snackbar/warning', err, {root: true});
    return false;
  }
};
// @ts-ignore
export const signOut = async ({dispatch}) => {
  try {
    dispatch('common/ui/setSidebar', false, {root: true});
    await Auth.signOut();
    return true;
  } catch (err: any) {
    dispatch('common/snackbar/warning', err, {root: true});
    return false;
  }
};
// @ts-ignore
export const changePassword = async ({dispatch}, {oldPassword, newPassword}) => {
  try {
    await Auth.currentAuthenticatedUser()
      .then((user) => Auth.changePassword(user, oldPassword, newPassword));
    dispatch('common/snackbar/success', 'Password changed', {root: true});
    return true;
  } catch (err: any) {
    dispatch('common/snackbar/warning', err, {root: true});
    return false;
  }
};
// @ts-ignore
export const forgotPassword = async ({commit, dispatch}, {username}) => {
  try {
    commit('setUsername', username);
    await Auth.forgotPassword(username);
    return true;
  } catch (err: any) {
    dispatch('common/snackbar/warning', err, {root: true});
    return false;
  }
};
// @ts-ignore
export const forgotPasswordSubmit = async ({dispatch}, {username, code, newPassword}) => {
  try {
    await Auth.forgotPasswordSubmit(username, code, newPassword);
    dispatch('common/snackbar/success', 'Password changed', {root: true});
    return true;
  } catch (err: any) {
    dispatch('common/snackbar/warning', err, {root: true});
    return false;
  }
};
// @ts-ignore
export const loadUser = async ({dispatch}) => {
  try {
    const user = await Auth.currentAuthenticatedUser();
    Sentry.setUser({ id: user.id, email: user.attributes.email });
    return true;
  } catch (err: any) {
    dispatch('common/snackbar/warning', err, {root: true});
    dispatch('common/loader/removeLoader', {}, {root: true});
    return false;
  }
};
